<p-avatar icon="pi pi-user" size="large" (click)="avatarMenu.toggle($event)"></p-avatar>
<p-tieredMenu #avatarMenu [model]="items" [popup]="true"></p-tieredMenu>
<app-changelog></app-changelog>
